// @core/api/endpoints/affiliate/get_offer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OfferResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get offer by ID
 * Retrieves offer by the specified identifier.
 */
export async function GetOffer(
  offer_id: string,
  options?: RequestOptions
): Promise<OfferResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/offers/:offer_id`;
  requestPath = requestPath.replace(':offer_id', encodeURIComponent(offer_id));
  const requestOptions = options;
  return client.get<OfferResponse>(requestPath, { ...requestOptions });
}
